import { navigateToUrl } from 'single-spa';

export const redirect = (path: string): void => navigateToUrl(`/${path}`.replace('//', '/'));
